import CompanyDesignerAllocationsPage from '../pages/admin/company-designer-allocations/company-designer-allocations-page'
export default CompanyDesignerAllocationsPage
